import { render, staticRenderFns, recyclableRender, components } from "./compensationDetails.vue?vue&type=template&id=710b5398&scoped=true&"
var renderjs
import script from "./compensationDetails.vue?vue&type=script&lang=js&"
export * from "./compensationDetails.vue?vue&type=script&lang=js&"
import style0 from "./compensationDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./compensationDetails.vue?vue&type=style&index=1&id=710b5398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710b5398",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/compensationDetails/compensationDetails.vue"
export default component.exports